/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type S4HanaQuoteItemDataHooksQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  quoteId: Types.Scalars['ID']['input'];
  itemId: Types.Scalars['ID']['input'];
}>;


export type S4HanaQuoteItemDataHooksQuery = { quoteSapS4HanaData?: { __typename: 'QuoteSapS4HanaData', id: string, configurableProductSupplierCatalogueIds: Array<string> } | null, quoteItemSapS4HanaData: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteItemSapS4HanaDataResult', items: Array<{ __typename: 'ItemSapS4HanaData', id: string, itemId: string, xId?: string | null, kmatBaseVariantProductIdLatest?: string | null, kmatProductIdLatest?: string | null }> } };

export type S4HanaIntegrationSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type S4HanaIntegrationSettingsQuery = { organisationIntegration: { __typename: 'MissingCapabilities' } | { __typename: 'OrganisationIntegrationResult', organisationIntegration?: { __typename: 'OrganisationIntegration', id: string, settings: any } | null } };


export const S4HanaQuoteItemDataHooksDocument = gql`
    query S4HanaQuoteItemDataHooks($projectId: ID!, $quoteId: ID!, $itemId: ID!) {
  quoteSapS4HanaData(projectId: $projectId, docId: $quoteId) {
    id
    configurableProductSupplierCatalogueIds
  }
  quoteItemSapS4HanaData(
    projectId: $projectId
    docId: $quoteId
    itemIds: [$itemId]
  ) {
    ... on QuoteItemSapS4HanaDataResult {
      items {
        id
        itemId
        xId
        kmatBaseVariantProductIdLatest
        kmatProductIdLatest
      }
    }
  }
}
    `;

/**
 * __useS4HanaQuoteItemDataHooksQuery__
 *
 * To run a query within a React component, call `useS4HanaQuoteItemDataHooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useS4HanaQuoteItemDataHooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useS4HanaQuoteItemDataHooksQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      quoteId: // value for 'quoteId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useS4HanaQuoteItemDataHooksQuery(baseOptions: Apollo.QueryHookOptions<S4HanaQuoteItemDataHooksQuery, S4HanaQuoteItemDataHooksQueryVariables> & ({ variables: S4HanaQuoteItemDataHooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<S4HanaQuoteItemDataHooksQuery, S4HanaQuoteItemDataHooksQueryVariables>(S4HanaQuoteItemDataHooksDocument, options);
      }
export function useS4HanaQuoteItemDataHooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<S4HanaQuoteItemDataHooksQuery, S4HanaQuoteItemDataHooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<S4HanaQuoteItemDataHooksQuery, S4HanaQuoteItemDataHooksQueryVariables>(S4HanaQuoteItemDataHooksDocument, options);
        }
export function useS4HanaQuoteItemDataHooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<S4HanaQuoteItemDataHooksQuery, S4HanaQuoteItemDataHooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<S4HanaQuoteItemDataHooksQuery, S4HanaQuoteItemDataHooksQueryVariables>(S4HanaQuoteItemDataHooksDocument, options);
        }
export type S4HanaQuoteItemDataHooksQueryHookResult = ReturnType<typeof useS4HanaQuoteItemDataHooksQuery>;
export type S4HanaQuoteItemDataHooksLazyQueryHookResult = ReturnType<typeof useS4HanaQuoteItemDataHooksLazyQuery>;
export type S4HanaQuoteItemDataHooksSuspenseQueryHookResult = ReturnType<typeof useS4HanaQuoteItemDataHooksSuspenseQuery>;
export type S4HanaQuoteItemDataHooksQueryResult = Apollo.QueryResult<S4HanaQuoteItemDataHooksQuery, S4HanaQuoteItemDataHooksQueryVariables>;
export const S4HanaIntegrationSettingsDocument = gql`
    query S4HanaIntegrationSettings {
  organisationIntegration(integrationId: sap_s4hana) {
    ... on OrganisationIntegrationResult {
      organisationIntegration {
        id
        settings
      }
    }
  }
}
    `;

/**
 * __useS4HanaIntegrationSettingsQuery__
 *
 * To run a query within a React component, call `useS4HanaIntegrationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useS4HanaIntegrationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useS4HanaIntegrationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useS4HanaIntegrationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<S4HanaIntegrationSettingsQuery, S4HanaIntegrationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<S4HanaIntegrationSettingsQuery, S4HanaIntegrationSettingsQueryVariables>(S4HanaIntegrationSettingsDocument, options);
      }
export function useS4HanaIntegrationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<S4HanaIntegrationSettingsQuery, S4HanaIntegrationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<S4HanaIntegrationSettingsQuery, S4HanaIntegrationSettingsQueryVariables>(S4HanaIntegrationSettingsDocument, options);
        }
export function useS4HanaIntegrationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<S4HanaIntegrationSettingsQuery, S4HanaIntegrationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<S4HanaIntegrationSettingsQuery, S4HanaIntegrationSettingsQueryVariables>(S4HanaIntegrationSettingsDocument, options);
        }
export type S4HanaIntegrationSettingsQueryHookResult = ReturnType<typeof useS4HanaIntegrationSettingsQuery>;
export type S4HanaIntegrationSettingsLazyQueryHookResult = ReturnType<typeof useS4HanaIntegrationSettingsLazyQuery>;
export type S4HanaIntegrationSettingsSuspenseQueryHookResult = ReturnType<typeof useS4HanaIntegrationSettingsSuspenseQuery>;
export type S4HanaIntegrationSettingsQueryResult = Apollo.QueryResult<S4HanaIntegrationSettingsQuery, S4HanaIntegrationSettingsQueryVariables>;